import { useEffect, useState } from "react";

const KEY = "wdww_cookie_consent_v1";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setVisible(true);
    } catch {
      /* private mode: just skip */
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(KEY, new Date().toISOString());
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-50 bg-black text-white border-t border-amber-500"
      data-testid="cookie-consent"
      role="dialog"
      aria-label="Cookie notice"
    >
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col sm:flex-row sm:items-center gap-4">
        <p className="text-sm leading-relaxed flex-1">
          <span className="mono text-[10px] uppercase tracking-[0.3em] text-amber-500 mr-2">Notice</span>
          This site uses cookies to keep you signed in. By continuing, you accept their use.
        </p>
        <button
          type="button"
          onClick={accept}
          data-testid="cookie-consent-accept"
          style={{ backgroundColor: "#fc4707" }}
          className="text-white px-6 py-2 mono text-xs uppercase tracking-[0.2em] hover:brightness-90 transition-all shrink-0"
        >
          Accept &amp; continue
        </button>
      </div>
    </div>
  );
}
